import * as React from 'react';
import { Text } from 'rebass';
export const KeyHint = (props) => {
    return React.createElement(Text, Object.assign({ fontSize: 1, color: "inputcolor" }, props));
};
